import jsonapi from 'jsonapi-parse';
import AIProofreaderOrder from '~/models/read/AIProofreaderOrder';
import AIProofreaderSubmittedDocument from '~/models/read/AIProofreaderSubmittedDocument';
import { findAIProofreaderPricing } from '~/functions/findAIProofreaderPricing';

export default $axios => ({ store }) => ({
    async list() {
        let response = await $axios.$get(`/api/v1/ai-proofreader/orders`);
        return jsonapi.parse(response).data.map(o => new AIProofreaderOrder(o)).sort((a, b) => a.id > b.id ? -1 : 1);
    },
    async get(id) {
        let response = await $axios.$get(`/api/v1/ai-proofreader/orders/${id}`);
        return new AIProofreaderOrder(jsonapi.parse(response).data);
    },

    async update(id, markedAsHasNoCitations) {
        let response = await $axios.$patch(`/api/v1/ai-proofreader/orders/${id}`, {
            'markedAsHasNoCitations': markedAsHasNoCitations,
        });
        return response;
    },
    async getAiProofreaderPricing() {
        try {
            let response = await $axios.$get(`/api/v1/ordering/${store.domain}/simple`, { noAuthHeader: true });
            let pricing = findAIProofreaderPricing(response);

            if (pricing) {
                pricing.pricing.sort((a, b) => a.price.amount - b.price.amount);

                return pricing;
            };
        } catch (error) {
            store.app.$sentry.captureException(error);
        }

        // If pricing is not found for the current domain, try the fallback domain
        try {
            const defaultDomainResponse = await $axios.$get(`/api/v1/ordering/scribbr.com/simple`, { noAuthHeader: true });
            return findAIProofreaderPricing(defaultDomainResponse);
        } catch (error) {
            store.app.$sentry.captureException(error);
            return [];
        }
    },
    getPreview(filename) {
        return new Promise(async (resolve, reject) => {
            await $axios.$get(`/order/ai-proofreader/${filename}/preview`, { withCredentials: false, ignoreLogout: true })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    uploadDocumentForAiProofreader(file, preview) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('uploadfiletype[file]', file);
            if (preview) {
                formData.append('preview', 'true');
            }

            $axios.$post('/order/ai-proofreader/document/', formData, {
                ignoreLogout: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } })
                .then(({ data }) => {
                    resolve(new AIProofreaderSubmittedDocument(data));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    async hasUserUnlimitedAIChecks() {
        try {
            const response = await $axios.$get('/order/ai-proofreader/unlimited-check/', { ignoreLogout: true });
            return jsonapi.parse(response);
        } catch (error) {
            return false;
        }
    },
    async getUploadedDocument(id, key) {
        try {
            const response = await $axios.$get(`/order/ai-proofreader/document/${id}?key=${key}`, { ignoreLogout: true });
            return new AIProofreaderSubmittedDocument(response.data);
        } catch (error) {
            return null;
        }
    },
});
